import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoResultSoftLight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 64,
	height: 40,
	viewBox: "0 0 64 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M49.5 15.5C49.5 23.7694 42.5755 30.5 34 30.5C25.4245 30.5 18.5 23.7694 18.5 15.5C18.5 7.23057 25.4245 0.5 34 0.5C42.5755 0.5 49.5 7.23057 49.5 15.5Z",
			stroke: "#8588D8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 34,
			cy: 16,
			r: 15.5,
			stroke: "#A8AAE3"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M48.4909 26C48.214 26.3453 47.9232 26.679 47.6191 27H57.0001C59.2093 27 61.0001 25.2091 61.0001 23V7C61.0001 4.79086 59.2093 3 57.0001 3H45.3296C45.7644 3.31257 46.1828 3.64641 46.5834 4H57.0001C58.657 4 60.0001 5.34315 60.0001 7V23C60.0001 24.6569 58.657 26 57.0001 26H48.4909Z",
			fill: "black",
			fillOpacity: .06
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M22.6706 3H7C4.79086 3 3 4.79086 3 7V23C3 25.2091 4.79086 27 7 27H20.381C20.077 26.679 19.7861 26.3453 19.5093 26H7C5.34315 26 4 24.6569 4 23V7C4 5.34315 5.34315 4 7 4H21.4167C21.8173 3.64641 22.2358 3.31257 22.6706 3Z",
			fill: "black",
			fillOpacity: .06
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M56.2942 36.3792L48.516 28.601C48.1255 28.2105 47.4923 28.2105 47.1018 28.601C46.7113 28.9915 46.7113 29.6247 47.1018 30.0152L54.88 37.7934C55.2705 38.1839 55.9037 38.1839 56.2942 37.7934C56.6847 37.4029 56.6847 36.7697 56.2942 36.3792ZM46.3947 27.8939C45.6136 28.6749 45.6136 29.9413 46.3947 30.7223L54.1729 38.5005C54.9539 39.2815 56.2202 39.2815 57.0013 38.5005C57.7823 37.7194 57.7823 36.4531 57.0013 35.6721L49.2231 27.8939C48.4421 27.1128 47.1757 27.1128 46.3947 27.8939Z",
			fill: "#8588D8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54 36.5L54.5 35.5",
			stroke: "#6C6DCE",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M52.5 35L53 34",
			stroke: "#6C6DCE",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.4013 19.6989C33.9474 19.7795 34.3252 20.2881 34.2447 20.8342C34.1641 21.3803 33.6555 21.7581 33.1094 21.6775C32.5633 21.5969 32.1855 21.0883 32.2661 20.5422C32.3467 19.9961 32.8553 19.6183 33.4013 19.6989ZM35.0558 8.48699C37.2414 8.80951 38.7515 10.8424 38.429 13.0281C38.2183 14.4559 37.6122 15.1246 36.1863 16.0147C34.7561 16.9068 34.4212 17.354 34.2555 18.4772L32.9365 18.2826C33.1772 16.6509 33.8151 15.9222 35.4806 14.8835C36.6065 14.181 36.9704 13.7792 37.11 12.8334C37.325 11.3759 36.3187 10.0211 34.8611 9.80605C33.4036 9.59097 32.0488 10.5973 31.8338 12.0549L31.7364 12.7144L30.4174 12.5198L30.5147 11.8602C30.8372 9.67456 32.8701 8.16448 35.0558 8.48699Z",
			fill: "#8588D8"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6 28V29C6 31.2091 7.79086 33 10 33H54C56.2091 33 58 31.2091 58 29V28H57V29C57 30.6569 55.6569 32 54 32H10C8.34315 32 7 30.6569 7 29V28H6Z",
			fill: "black",
			fillOpacity: .04
		})
	]
});
export default SvgNoResultSoftLight;
